import { createRouter, createWebHistory } from 'vue-router'
import Login from '@/views/Login.vue'
import SearchPlayground from '@/views/SearchPlayground.vue'
import Privacy from '@/views/Privacy.vue'
import ApiKeyManagement from '@/views/ApiKeyManagement.vue'
import SubscriptionUsage from '@/views/SubscriptionUsage.vue'

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    props: (route) => ({ cid: route.query.cid })
  },
  {
    path: '/search',
    name: 'SearchPlayground',
    component: SearchPlayground
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: Privacy
  },
  {
    path: '/api-keys',
    name: 'ApiKeyManagement',
    component: ApiKeyManagement
  },
  {
    path: '/subscription',
    name: 'SubscriptionUsage',
    component: SubscriptionUsage
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const userInfo = localStorage.getItem('userInfo')
  
  // 如果访问登录页面且已登录，重定向到搜索页面
  if (to.path === '/login' && userInfo) {
    next('/search')
    return
  }
  
  // 如果访问需要登录的页面但未登录，重定向到登录页面
  if (to.path !== '/login' && !userInfo) {
    next('/login')
    return
  }
  
  next()
})

export default router